import React from "react";
import {
  usePagination,
  Pagination as InstaSearchPagination,
} from "react-instantsearch";
import { ReactComponent as NextIcon } from "../../assets/icons/arrow-right.svg";
import { PaginationConnectorParams } from "instantsearch.js/es/connectors/pagination/connectPagination";

interface PaginationProps {
  [x: string]: any;
}

const Pagination: React.FC<PaginationProps> = (
  props: PaginationConnectorParams & PaginationProps
) => {
  const { currentRefinement, nbPages } = usePagination(props);
  if (!!nbPages) {
    return (
      <>
        <InstaSearchPagination
          {...props}
          showPrevious={currentRefinement !== 0}
          showNext={currentRefinement !== nbPages - 1}
          showLast={false}
          showFirst={false}
          classNames={
            {
              // nextPageItem: "Pagination-item--nextPage",
              // previousPageItem: "Pagination-item--previousPage",
              // link: "Pagination-link",
              // list: "Pagination-list",
              // item: "Pagination-item--page",
            }
          }
          translations={{
            nextPageItemText: " ",
            previousPageItemText: " ",
            nextPageItemAriaLabel: "Next page",
            previousPageItemAriaLabel: "Previous page",
          }}
        />
      </>
    );
  }

  return null;
};

export const CustomPagination = Pagination;
